





































import { Component, mixins } from '@niknevis/vue-modules'
import { Prop, ProvideReactive } from 'vue-property-decorator'
import {
  DepositBankAccountCollectionType
} from '@/modules/deposit-bank-account/models/deposit-bank-account-collection.model'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import PaginationWithInput from '@/modules/shared/components/shared/pagination/PaginationWithInput.vue'
import { QsSearchableMixin } from '@/modules/shared/mixins/qs-searchable.mixin'
import { QsPaginatableMixin } from '@/modules/shared/mixins/qs-paginatable.mixin'
import AdminDepositBankAccountIndexPageTableRow
  from '@/modules/deposit-bank-account/components/admin/table/AdminDepositBankAccountIndexPageTableRow.vue'
import {
  adminDepositBankAccountIndexPageTableColumn
} from '@/modules/deposit-bank-account/models/columns/admin-deposit-bank-account-index-page-table.column'
import { Filter, FilterTypes } from '@/modules/common/filter/filter'
import collect from 'collect.js'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import AdminCreateDepositBankAccountDialog
  from '@/modules/deposit-bank-account/components/admin/AdminCreateDepositBankAccountDialog.vue'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'حساب‌های شرکت'
  },
  metaInfo: {
    title: 'حساب‌های شرکت'
  },
  components: {
    BaseButton,
    PaginationWithInput,
    TesTable,
    FilterRow
  }
})
export default class AdminDepositBankAccountIndexPage extends mixins(QsSearchableMixin, QsPaginatableMixin) {
  @Prop() accounts: DepositBankAccountCollectionType

  private rowComponent = AdminDepositBankAccountIndexPageTableRow

  private columns = adminDepositBankAccountIndexPageTableColumn()

  private filters = [
    new Filter({
      type: FilterTypes.Select,
      title: 'وضعیت',
      key: 'status',
      holder: 'انتخاب کنید',
      default: this.accounts.default_filters.status,
      typeMode: false,
      items: collect(this.accounts.statuses)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    }),
    new Filter({
      type: FilterTypes.Select,
      title: 'نوع حساب',
      key: 'account_type',
      holder: 'انتخاب کنید',
      typeMode: false,
      items: collect(this.accounts.account_types)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    })
  ]

  @ProvideReactive()
  protected get fixedData() {
    return {
      accountTypes: this.accounts.account_types,
      statuses: this.accounts.statuses
    }
  }

  protected get model() {
    return this.accounts
  }

  private updatePage(page: number) {
    this.updateTable({
      pagination: {
        ...this.pagination,
        page
      }
    })
  }

  private openCreateDepositBankAccountDialog() {
    this.$q.dialog({
      component: AdminCreateDepositBankAccountDialog,
      bankAccountTypesInPersian: this.accounts.account_types,
      depositBankAccountStatusesInPersian: this.accounts.statuses
    })
  }
}
